import Immutable from 'immutable';
import * as types from './BrochureEditor.types';

const initialState = {
    templateCode: null,
    variables: {
        quantity: '',
        type: '1',
        clinicName: '',
        address: '',
        city: '',
        zip: '',
        main: '',
        fax: '',
    },
    brochure: null,
    fetching: false,
    addingToCart: false,
    isFavorite: false,
    addingFavorite: false,
    checkingFavorite: false,
    savingWork: false,
    action: null,
}

export default function (state = initialState, action) {
    state = Immutable.fromJS(state);
    switch (action.type) {
        case types.FETCH_BROCHURE:
            return state.setIn(['fetching'], true).toJS();

        case types.FETCH_BROCHURE_SUCCESS:
            return state.setIn(['fetching'], false)
                .setIn(['brochure'], action.payload)
                .toJS();

        case types.FETCH_BROCHURE_ERROR:
            return state.setIn(['fetching'], false).toJS();

        case types.ADD_TO_CART:
            if (parseInt(action.payload) === 2) {
                return state.setIn(['savingWork'], true).toJS();
            }
            return state.setIn(['addingToCart'], true).toJS();

        case types.ADD_TO_CART_SUCCESS:
            return state.setIn(['addingToCart'], false)
                .setIn(['savingWork'], false)
                .toJS();

        case types.ADD_TO_CART_ERROR:
            return state.setIn(['addingToCart'], false)
                .setIn(['savingWork'], false)
                .toJS();

        case types.SET_TEMPLATE_CODE:
            return state.setIn(['templateCode'], action.payload).toJS();

        case types.SET_QUANTITY:
            return state.setIn(['variables', 'quantity'], action.payload).toJS();

        case types.SET_NOTES:
            return state.setIn(['variables', 'notes'], action.payload).toJS();

        case types.ADD_FAVORITE:
            return state.setIn(['addingFavorite'], true).toJS();

        case types.ADD_FAVORITE_SUCCESS:
            return state.setIn(['addingFavorite'], false)
                .setIn(['isFavorite'], parseInt(action.payload.type) === 1)
                .toJS();

        case types.ADD_FAVORITE_ERROR:
            return state.setIn(['addingFavorite'], false).toJS();

        case types.CHECK_FAVORITE:
            return state.setIn(['checkingFavorite'], true).toJS();

        case types.CHECK_FAVORITE_SUCCESS:
            return state.setIn(['checkingFavorite'], false)
                .setIn(['isFavorite'], parseInt(action.payload.favorite) === 1)
                .toJS();

        case types.CHECK_FAVORITE_ERROR:
            return state.setIn(['checkingFavorite'], false).toJS();

        case types.SET_ACTION:
            return state.setIn(['action'], action.payload).toJS();

        case types.SET_TYPE:
            return state.setIn(['variables', 'type'], action.payload).toJS();

        case types.SET_CLINIC_NAME:
            return state.setIn(['variables', 'clinicName'], action.payload).toJS();

        case types.SET_ADDRESS:
            return state.setIn(['variables', 'address'], action.payload).toJS();

        case types.SET_CITY:
            return state.setIn(['variables', 'city'], action.payload).toJS();

        case types.SET_ZIP:
            return state.setIn(['variables', 'zip'], action.payload).toJS();

        case types.SET_MAIN:
            return state.setIn(['variables', 'main'], action.payload).toJS();

        case types.SET_FAX:
            return state.setIn(['variables', 'fax'], action.payload).toJS();

        case types.RESET_STATE:
            return initialState;

        default:
            return state.toJS();
    }
}